"use client";

import React from "react";

import { BrowserGraphic } from "./browser-preview-graphic";
import FormPreview from "./form-preview";

interface FormPreviewBrowserProps {
  domain: string;
}

const FormPreviewBrowser: React.FC<FormPreviewBrowserProps> = ({ domain }) => {
  return (
    <div className="w-full max-w-2xl mx-auto">
      <BrowserGraphic domain={domain || "careers.yourcompany.com/apply"}>
        <div className="p-4">
          <FormPreview />
        </div>
      </BrowserGraphic>
    </div>
  );
};

export default FormPreviewBrowser;
